<template>
  <b-container class="mt-4 auth-page">
    <b-row class="justify-content-md-center">
      <b-col cols="12" xl="5" lg="6" md="8" sm="12">
        <b-alert variant="primary" show>
          Benvenuto nel sito del Progetto Turismo finanziato da DIH, Digital
          Innovation Hub.
        </b-alert>

        <div class="justify-content-md-center text-center">
          <img src="/datacatalog-simple/images/logo.png" alt />
        </div>

        <b-card
          title="Accesso"
          img-src="/datacatalog-simple/images/logo-evento.jpg"
          img-alt="Image"
          img-top
          tag="article"
          class="mt-4 b-form-1 basic-box-shadow"
        >
          <p>Inserisci le tue credenziali per accedere al portale.</p>
          <b-form @submit.prevent="signIn">
            <b-form-group label="Email:" label-for="emailInput">
              <b-form-input
                id="emailInput"
                type="email"
                v-model="email"
                required
                placeholder="Inserisci la tua email"
              />
            </b-form-group>
            <b-form-group label="Password:" label-for="passwordInput">
              <b-form-input
                id="passwordInput"
                type="password"
                v-model="pass"
                required
                placeholder="Inserisci la tua password"
              />
              <p class="mt-2">
                Hai
                <router-link :to="{ name: 'passwordReset' }">dimenticato la password</router-link>?
              </p>
            </b-form-group>

            <b-button v-show="!submitting" type="submit" variant="primary">Accedi</b-button>

            <b-button v-show="submitting" variant="primary" disabled>
              <b-spinner style="width: 1.4rem; height: 1.4rem;" label="Loading..."></b-spinner>
              <span class="sr-only">Loading...</span>
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center mt-3">
      <b-col cols="12" xl="5" lg="6" md="8" sm="12">
        <v-alert />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*
  With this form the user can authenticate to the application
*/

import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '@/router'
import store from '@/store'

import Alert from '@/components/auth/Alert.vue'

Vue.component('v-alert', Alert)

export default {
  data () {
    return {
      email: '',
      pass: '',
      submitting: false
    }
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'needsNewPassword'])
  },
  mounted () {
    // if this page was loaded from a redirect, check if there was something to show with a (toast) alert
    const alert = this.$route.params.alert
    if (alert) {
      this.$bvToast.toast(alert.message, {
        title: alert.title,
        autoHideDelay: 4000,
        appendToast: false,
        variant: 'warning',
        solid: true
      })
    }
  },
  methods: {
    async signIn () {
      this.submitting = true

      // authenticate the user with his email and password
      await store.dispatch('auth/signIn', {
        username: this.email,
        password: this.pass
      })

      this.submitting = false

      if (this.needsNewPassword) {
        // if it's the first time that the user is logging in, redirect him to the new password form
        router.push({ name: 'newPassword' }).catch(err => console.error(err))
      } else if (!this.hasAuthenticationStatus) {
        const returnTo = this.$route.params.returnTo

        if (returnTo) {
          // if the user is coming from another dashboard, redirect him to that dashboard after authenticating
          router.push({ name: returnTo }).catch(err => console.error(err))
          return
        }

        // go back to the home page
        router.push({ name: 'home' }).catch(err => console.error(err))
      }
    }
  }
}
</script>

<style scoped>
.b-form-1 {
  padding: 0;
}

.card-img-top {
  padding: 1rem;
  padding-bottom: 0;
}
</style>
